import React from 'react';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import { Field, reduxForm } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';

let RequestContractorForm = props => {
  return (
    <div className="row">
      <p style={{ padding: '0 15px' }}>
        If you require a contractor to complete the job, provide additional details as to why and
        click the submit button.
      </p>
      <div className="row" style={{ textAlign: 'center' }}>
        <div className="col-xs-12" style={{ margin: '10px 0' }}>
          <Field
            name="internal_note"
            component={TextField}
            label="Internal Notes"
            hintStyle={{ fontSize: '13px' }}
            rows="2"
            multiline
            fullWidth
            validate={[validator.required]}
            variant="outlined"
            style={{
              marginTop: '2px',
              fontSize: '15px',
              marginBottom: '-8px',
            }}
          />
        </div>
      </div>
      <div className="row" style={{ marginTop: '15px', textAlign: 'center' }}>
        <FlatButton
          label="Complete"
          onClick={props.handleSubmit}
          primary
          hoverColor="grey"
          backgroundColor={AccentColor()}
          style={{
            color: colors.WHITE,
            height: '40px',
          }}
        />
      </div>
    </div>
  );
};

RequestContractorForm = reduxForm({
  form: 'request_contractor_maintenance_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(RequestContractorForm);

export default RequestContractorForm;
